<div class="constraint-option-assignment-editor">
  <div class="main-layout">
    <div class="column">
      <div class="column-layout">
        <div class="header-label">
          {{'Configured Options' |
          translate:['tmc-yard.entity.transport-options-administration.constraint-option-assignment-editor.columns.configured',translationService.language
          ]}}</div>
        <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="assignedOptions" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[configuredList]" class="list" (cdkDropListDropped)="drop($event)">
          <div class="list-item-box" *ngFor="let item of assignedOptions" cdkDrag>
            <div class="list-item">
              {{ item | translateDictionaryEntry:[item.name, translationService.language]}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="column">
      <div class="column-layout">
        <div class="header-label">
          {{'Available Options' |
          translate:['tmc-yard.entity.transport-options-administration.constraint-option-assignment-editor.columns.available',translationService.language
          ]}}
        </div>
        <div cdkDropList #configuredList="cdkDropList" [cdkDropListData]="availableOptions" cdkDropListSortingDisabled
          [cdkDropListConnectedTo]="[availableList]" class="list" (cdkDropListDropped)="dropToAvailableList($event)">
          <div class="list-item-box" *ngFor="let item of availableOptions" cdkDrag>
            <div class="list-item">
              {{ item | translateDictionaryEntry:[item.name, translationService.language]}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
